import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaUserCircle, FaSignOutAlt } from "react-icons/fa";

import { logout } from "../slices/auth";
import EventBus from "../common/EventBus";

// =============================================================================
// UserSidebar (Folgeprompt 15)
// -----------------------------------------------------------------------------
// Wiederverwendbare, fuer ALLE Stufen identische Konto-/Logout-Leiste unten
// links. Datengetrieben (Username/Rolle aus dem auth-State), keine
// Stufen-Sonderfaelle im Markup. Touchflaechen >= 44px, Safe-Area-faehig,
// Dark-Mode-/WCAG-tauglich (Styles in App.css unter .myn-usb*).
//   - Klick auf den User-Eintrag  -> Konto-Seite "/account"
//   - Logout-Eintrag darunter      -> Token invalidieren + Redirect /login
// Wird nur gerendert, wenn ein Benutzer eingeloggt ist.
// =============================================================================

const UserSidebar = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    dispatch(logout());
    EventBus.dispatch("logout");
    navigate("/login");
  }, [dispatch, navigate]);

  if (!currentUser) {
    return null;
  }

  // Primaere Rolle (erste Rolle) nur zur reinen Anzeige, ohne Logiksonderfall.
  const primaryRole =
    Array.isArray(currentUser.roles) && currentUser.roles.length
      ? currentUser.roles[0].replace(/^ROLE_/, "")
      : "";

  const goToAccount = () => navigate("/account");

  const onAccountKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      goToAccount();
    }
  };

  return (
    <aside className="myn-usb" aria-label="Benutzerkonto">
      <button
        type="button"
        className="myn-usb__user"
        onClick={goToAccount}
        onKeyDown={onAccountKeyDown}
        title="Zum Konto"
        aria-label={`Konto von ${currentUser.username} oeffnen`}
      >
        <FaUserCircle className="myn-usb__avatar" aria-hidden="true" />
        <span className="myn-usb__meta">
          <span className="myn-usb__name">{currentUser.username}</span>
          {primaryRole && <span className="myn-usb__role">{primaryRole}</span>}
        </span>
      </button>

      <button
        type="button"
        className="myn-usb__logout"
        onClick={handleLogout}
        aria-label="Abmelden"
      >
        <FaSignOutAlt aria-hidden="true" />
        <span>Abmelden</span>
      </button>
    </aside>
  );
};

export default UserSidebar;
